import { render } from "./WizardCustomization.vue?vue&type=template&id=e0f01a6a"
import script from "./WizardCustomization.vue?vue&type=script&lang=js"
export * from "./WizardCustomization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__